import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'
import { Slider } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

const CustomSlider = styled(Slider)`
  .ant-slider-mark-text {
    font-size: ${font.size.sm};
  }
`

const SliderWrapper = styled.div`
  padding: 0 20px 5px;
`

const CH = props => {
  const [currentValues, setCurrentValues] = useState([])

  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { horsepowerMin, horsepowerMax } = filters
  const chsList = filtersDatas.horsepowers

  const formatter = value => {
    const intlValue = intl.formatNumber(value)
    return `${intlValue} Ch/DIN`
  }

  const marks = {}

  const maxValue = currentValues[1]
  const minValue = currentValues[0]

  marks[maxValue] = formatter(maxValue)
  marks[minValue] = formatter(minValue)

  const onChange = value => {
    setCurrentValues(value)
  }

  const handleOnChangeFiltre = item => {
    const [min, max] = item

    const extendedFiltersValues = {
      ...filters,
      horsepowerMin: min,
      horsepowerMax: max
    }

    onChangeFilter(extendedFiltersValues)
  }

  useEffect(() => {
    const values = []
    if (chsList) {
      const maxVal = horsepowerMax || chsList.max
      const minVal = horsepowerMin || chsList.min

      values[0] = minVal
      values[1] = maxVal
    }
    setCurrentValues(values)
  }, [])

  return (
    <div data-test="component-stock-vehicles-list-filters-ch">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-CH-title'
        })}
        data-test="stock-vehicles-list-filters-ch-title"
      />
      <SliderWrapper>
        <CustomSlider
          defaultValue={currentValues}
          max={chsList.max}
          min={chsList.min}
          step={chsList.step}
          range
          marks={marks}
          onAfterChange={value => handleOnChangeFiltre(value)}
          onChange={value => onChange(value)}
          tooltipVisible={false}
          data-test="stock-vehicles-list-filters-ch-slider"
        />
      </SliderWrapper>
    </div>
  )
}

CH.propTypes = {
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default injectIntl(CH)
